import React from 'react';
import { Card } from 'react-bootstrap';

export const LoadingState: React.FC<{ label?: string }> = ({ label = 'Loading your workspace' }) => (
  <div className="workspace-loading" role="status" aria-live="polite">
    <span className="visually-hidden">{label}</span>
    <div className="workspace-skeleton workspace-skeleton--title" />
    <div className="workspace-metrics">{[0, 1, 2, 3].map(item => <div className="workspace-skeleton workspace-skeleton--card" key={item} />)}</div>
    <div className="workspace-skeleton workspace-skeleton--panel" />
  </div>
);

export const SummaryCard: React.FC<{ label: string; value: string; note?: string; tone?: string }> = ({ label, value, note, tone }) => (
  <Card className="workspace-metric"><Card.Body>
    <span>{label}</span><strong className={tone || ''}>{value}</strong>{note && <small>{note}</small>}
  </Card.Body></Card>
);
